const createImage = (url) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', (error) => reject(error));
        image.setAttribute('crossOrigin', 'anonymous'); // todo: remove?
        image.src = url;
    });
};

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} imageSrc - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param fileName
 */
export async function getCroppedImg(imageSrc, pixelCrop, fileName) {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const maxSize = Math.max(image.width, image.height);
    const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

    // set each dimensions to double largest dimension to allow for a safe area for the
    // image to rotate in without being clipped by canvas context
    canvas.width = safeArea;
    canvas.height = safeArea;

    // translate canvas context to a central location on image to allow rotating around the center.
    ctx.translate(safeArea / 2, safeArea / 2);
    ctx.translate(-safeArea / 2, -safeArea / 2);

    // draw rotated image and store data.
    ctx.drawImage(
        image,
        safeArea / 2 - image.width * 0.5,
        safeArea / 2 - image.height * 0.5
    );
    const data = ctx.getImageData(0, 0, safeArea, safeArea);

    // set canvas width to final desired crop size - this will clear existing context
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    // paste generated rotate image with correct offsets for x,y crop values.
    ctx.putImageData(
        data,
        Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
        Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
    );

    return new Promise((resolve) => {
        const b64 = canvas.toDataURL(null, 0.8);
        resolve({
            src: b64,
            file: dataURLtoFile(b64, fileName),
        });
    });
}

const dataURLtoFile = (dataurl, name = 'file', forceJPG = false) => {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let ext = mime.split('/');
    ext = ext[ext.length - 1];

    let fileName = name;

    if (fileName.includes('.')) {
        fileName = name.split('.');
        fileName.pop();
        fileName = fileName.join('.');
    }

    let fileExt = 'jpg';

    if (forceJPG) {
        mime = 'image/jpeg';
    } else {
        if (ext === 'png') fileExt = 'png';
    }

    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], `${fileName}.${fileExt}`, { type: mime });
};

export function cropImage(url) {
    return new Promise((resolve) => {
        const inputImage = new Image();
        inputImage.src = url;

        inputImage.onload = () => {
            // let's store the width and height of our image
            let inputWidth = inputImage.naturalWidth;
            let inputHeight = inputImage.naturalHeight;

            let outputWidth;
            let outputHeight;

            let greaterSize =
                inputWidth >= inputHeight ? inputWidth : inputHeight;

            outputWidth = greaterSize;
            outputHeight = greaterSize;

            // calculate the position to draw the image at
            const outputX = (outputWidth - inputWidth) * 0.5;
            const outputY = (outputHeight - inputHeight) * 0.5;

            // create a canvas that will present the output image
            const outputImage = document.createElement('canvas');

            // set it to the same size as the image
            outputImage.width = outputWidth;
            outputImage.height = outputHeight;

            // draw our image at position 0, 0 on the canvas
            const ctx = outputImage.getContext('2d');
            ctx.drawImage(inputImage, outputX, outputY);

            // change non-opaque pixels to white
            let imgData = ctx.getImageData(
                0,
                0,
                outputImage.width,
                outputImage.height
            );
            let data = imgData.data;
            for (let i = 0; i < data.length; i += 4) {
                if (data[i + 3] < 255) {
                    data[i] = 255 - data[i];
                    data[i + 1] = 255 - data[i + 1];
                    data[i + 2] = 255 - data[i + 2];
                    data[i + 3] = 255 - data[i + 3];
                }
            }
            ctx.putImageData(imgData, 0, 0);

            let output = outputImage;

            // Resize image to 500x500;
            if (greaterSize > 500) {
                const outputImageResized = document.createElement('canvas');
                const resizedContext = outputImageResized.getContext('2d');

                outputImageResized.height = 500;
                outputImageResized.width = 500;

                resizedContext.drawImage(outputImage, 0, 0, 500, 500);

                output = outputImageResized;
            }

            const b64 = output.toDataURL('image/jpeg', 0.8);
            resolve({
                src: b64,
                file: dataURLtoFile(b64, 'logo', true),
            });
        };
    });
}
